import React from "react"
import { Platform } from "react-native"
import { Text as GluestackText } from "./gluestack/text"

export interface TextProps extends React.ComponentProps<typeof GluestackText> {
  className?: string
  numberOfLines?: number
}

export const Text = ({
  children,
  className,
  numberOfLines,
  ...props
}: TextProps) => {
  // On web, filter out React Native specific props
  if (Platform.OS === "web") {
    // Don't pass numberOfLines to web DOM elements
    return (
      <GluestackText className={className} {...props}>
        {children}
      </GluestackText>
    )
  }

  // On native, pass all props including numberOfLines
  return (
    <GluestackText
      className={className}
      numberOfLines={numberOfLines}
      {...props}
    >
      {children}
    </GluestackText>
  )
}
